<script>
const quickResponse = () => import ('@/components/quick-response');
//const dolyami = () => import ('@/components/dolyami');
const carouselItems = () => import ('@/components/carousel-items');
const PopupProduct = () => import ('@/components/popup-product');
const Feedbacks = () => import ('@/components/feedbacks-card');
import catalog from '@/mixins/catalog';
import {VLazy} from 'vuetify/lib';

export default {
    
    name:"element-product",
        mixins: [catalog],
        props: ['arResult', 'ajaxParams'],
        components: {
                "quick-response":quickResponse,
                "feedbacks-card": Feedbacks,
                //"dolyami":dolyami,
                "carousel-items": carouselItems,
                "v-lazy": VLazy,
                "popup-product": PopupProduct},
                        data: function(){  
                            return {
                                responseAjax:"",
                                addProduct:{},
                                loading: false,
                                activeChar: false,
                                activeDescr: false,
                                activeSlide: 0,
                                countFeeds:0,
                                pageFeed:false,
                                tab:null,
                                activeOffer:0,
                                originalId:0,
                                url:"/bitrix/services/main/ajax.php",
                                showD:false,
                                nav:false,
                                offerActive:{},
                                subscribeActive: false,
                                subscribeEmail:""
                            }
                        },
                        computed: {
                            
                            priceAfterDis: function()
                            {
                            
                                let current_price = parseInt(this.arResult.PRICE);
                                //console.log(current_price);
                                let calc_price = 0;
                                calc_price = parseInt(current_price - (current_price * 0.10));

                                return calc_price;
                            }

                        },

                        filters:{

                            currency: function(value)
                            {
                                if (typeof value !== "number") {
                                        return value;
                                    }
                                    var formatter = new Intl.NumberFormat('ru-Ru', {
                                        style: 'currency',
                                        currency: 'RUB',
                                        maximumFractionDigits:0
                                    });
                                
                                    return formatter.format(value);
                            }
                        },
                        created () {

                           
                            //window.addEventListener('scroll', this.onScrollBlock);
                            //console.log(this);
                          
                            //var $window  = $(window);

                            let product = {"id": this.arResult.ID,
                                           "name": this.arResult.NAME,
                                           "price": parseInt(this.arResult.PRICE),
                                           "category": this.arResult.PATH[this.arResult.PATH.length - 2].NAME
                                        };

                            //console.log(product);
                             this.$ecommerce.viewProduct(product);

                        },

                        destroyed () {


                            //window.removeEventListener('scroll', this.onScrollBlock);
                        },
                       
                        mounted: function () {

                            

                           

                            //this.arResult = JSON.parse(this.arResult);

                            this.originalId = this.arResult.ID;
                            console.log(this.arResult);
                            if(this.arResult.FEEDBACKS)
                            {
                                this.countFeeds = this.arResult.FEEDBACKS.length;
                            }
                                        
                                        if(!this.arResult.hasOwnProperty('GALLERY'))
                                        {
                                            this.arResult.GALLERY = {LARGE:[{src: this.componentPath+"/images/shop.png"}],
                                                                    ORIGINAL:[{src: this.componentPath+"/images/shop.png"}],
                                                                    SMALL: [{src: this.componentPath+"/images/shop.png"}]};
                                            //this.arResult.GALLERY.LARGE[0].src = ;
                                           
                                        }
                            
                            if(this.arResult.OFFERS)
                            {
                                //console.log(this.arResult.OFFERS.PROPS);
                                for(let key in this.arResult.OFFERS.PROPS)
                                {

                                    //console.log(key);

                                    for(let id in this.arResult.OFFERS.PROPS[key])
                                    {
                                        let prop = this.arResult.OFFERS.PROPS[key][id];

                                        this.activeOffer = prop.ID;
                                        break;
                                    }
                                    

                                    break;
                                }
                                
                            }     

                            //console.log(this.activeOffer);
                            
                            this.changeOffer();
                            this.offerActive = this.arResult.CUSTOM_OFFERS[0];

                                window.addEventListener('b24:form:init', (event) => {
                                        let form = event.detail.object;

                                        if (form.identification.id == "18") {
                                        
                                            setTimeout(() => {
                                                
                                                $(".b24-form-header").after($(".hide-form"));
                                            }, 100);
                                            
                                            //console.log(event);
                                            //$(form).append($(".block-product-discount").html());
                                            
                                        }
                                });
                     
                        },
                        methods:{

                       
                            setOffer()
                            {
                                this.arResult.ID = this.offerActive.ID;
                                this.arResult.NAME = this.offerActive.NAME;
                                this.arResult.FORMAT_PRICE = this.offerActive.FORMAT_PRICE;
                                this.arResult.FORMAT_PRICE_OLD = this.offerActive.FORMAT_PRICE_OLD;
                                this.arResult.PRICE_OLD = this.offerActive.PRICE_OLD;
                                this.arResult.DISCOUNT_PR = this.offerActive.DISCOUNT_PR;
                                //console.log(this.offerActive);
                            },

                            goPrevSlide: function(){

                                this.$refs.swiper2.swiper.slidePrev();
                                //console.log(this.$refs);
                                

                            },

                            goNextSlide: function(){

                                //console.log(this.$refs);
                                this.$refs.swiper2.swiper.slideNext();
                               

                            },

                            setThumbsSwiper: function(swiper)
                            {
                                thumbsSwiper = swiper;
                            },

                            changeOffer: function()
                            {
                                let current_offer = [];
                                let current_prop = [];

                                for(let offer in this.arResult.OFFERS.ITEMS)
                                {
                                    current_offer = this.arResult.OFFERS.ITEMS[offer];
                                   

                                    for(let prop in current_offer.PROPS)
                                    {
                                        current_prop = current_offer.PROPS[prop][0];
                                       
                                        if(current_prop.VALUE == this.activeOffer)
                                        {
                                            //console.log(current_offer);
                                            this.arResult.ID = current_offer.ID;
                                            this.arResult.NAME = current_offer.NAME;
                                            this.arResult.FORMAT_PRICE = current_offer.FORMAT_PRICE;
                                        }
                                    }

                                  
                                }
                                
                            },

                            showPageFeedbacks: function(){

                                this.pageFeed = true;
                          

                            },

                            orderCredit: function(){

                                $(".order_credit").click();
                            },
                            showFastBuy: function(){

                                    $(".fast_order").click();
                            },
                            addProductHandler: function(item)
                            {
                                //this.addProduct = item;

                                $.fancybox.open({
                                    src  : '#card_block',
                                    type : 'inline',
                                    opts : {
                                        afterShow : function( instance, current ) {
                                            console.info( 'done!' );
                                        }
                                    }
                                });
                                //console.log(item);
                                 
                            },


                            showDisc: function()
                            {
                                if(this.activeDescr)
                                {
                                    this.activeDescr = false;
                                }
                                else
                                {
                                    this.activeDescr = true;
                                }
                                
                            },

                            scrollToChar: function(){

                        
                                let el = this.$refs.tabChar;
                                this.$refs.tabs.changeTab(el);
                                //console.log(el);
                              
                                 $('html, body').animate({
                                             scrollTop: $(".tabs").offset().top
                                 }, 800);
                            },

                            syncSliders: function(currentSlide, slide){

                                //console.log(currentSlide);
                                //console.log(slide);
                                this.activeSlide = slide;
                                this.$refs['slickGallery'].goTo(slide);
                                this.$refs['slickSmallGallery'].goTo(slide);
                            },

                            prepareImages: function(items){

                              
                            },

                            sendSubscribe(){

                                //console.log(this.subscribeEmail);

                                // return false;
                                //console.log($(".email-sub")[0].checkValidity());
                                if(!$(".email-sub")[0].checkValidity() || this.subscribeEmail == "")
                                {
                                    //console.log("ddsd");
                                    $(".email-sub")[0].reportValidity();
                                    return false;
                                }


                                 let vue = this;
                                 let params_query = new URLSearchParams({
                                        mode: "class",
                                        //nav_feed: "page-"+this.pageFeedbacks,
                                        c: "vue:one_element",
                                        action:"addSubscribe",
                                });

                                $.ajax({
                                    type: "POST",
                                    url: "/bitrix/services/main/ajax.php?"+params_query.toString(),
                                    data: {id: this.arResult.ID, 
                                            email:this.subscribeEmail,
                                            signedParameters: this.ajaxParams.signedParameters, 
                                            //page: this.pageFeedbacks, 
                                            //order: this.order
                                        },
                                    headers: {'x-bitrix-csrf-token': this.ajaxParams.token,
                                             'x-bitrix-site-id': this.ajaxParams.sideId },
                                    //dataType: "dataType",
                                    success: function (response) {

                                        if (response.status === 'success') {

                                            vue.subscribeActive = true;

                                        }
                                        //console.log(response);
                                    }
                                });
                            },

                           showFancy: function(index){

                            //console.log(index);
                                let arrImages = [];

                                this.arResult.GALLERY.ORIGINAL.forEach(element => {
                                    
                                    arrImages.push({src  : element.src,
                                                    // opts : {
                                                    //     caption : 'First caption',
                                                    //     thumb   : '1_s.jpg'
                                                    // }
                                                });
                                });
                                         
    
                                    $.fancybox.open(arrImages, {
                                            loop : true
                                        });

                                    $.fancybox.getInstance().jumpTo(index);
                           },

                           
                 

                            

                        }
    

}

</script>

<template>
    <div class="container">
        <h1  class="el-name">
            {{this.arResult.NAME}}
        </h1>
        <div class="stars" >
            <v-rating
                    readonly
                    length="5"
                    color="yellow darken-3"
                    background-color="grey darken-1"
                    :value="parseInt(arResult.RATING)"
                        >
                                                            
            </v-rating>
            <div class="count-feed">({{getCountFeed(arResult)}})</div>
        </div>
        <div class="fl-cont-cont">
            <div class="row">
            <div div class="col-xl-9">
                <div class="row mar-b-cont" v-if="arResult">
                
                    <div class="col-xl-8 cor-st">

                        <div class="row">
                            <div class="col-xl-3">
                                <div class="prev-vert-arrow" @click="goPrevSlide" v-if="arResult.GALLERY.SMALL.length > 4">
                                    <svg width="11" height="20" viewBox="0 0 11 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.38296 20.0762C0.111788 19.805 0.111788 19.3654 0.38296 19.0942L9.19758 10.2796L0.38296 1.46497C0.111788 1.19379 0.111788 0.754138 0.38296 0.482966C0.654131 0.211794 1.09379 0.211794 1.36496 0.482966L10.4341 9.55214C10.8359 9.9539 10.8359 10.6053 10.4341 11.007L1.36496 20.0762C1.09379 20.3474 0.654131 20.3474 0.38296 20.0762Z" fill="currentColor" transform-origin="center" transform="rotate(180)"></path></svg>
                                </div>
                                <swiper-container
                                :slides-per-view="4"
                                :loop="false"
                                :direction="'vertical'"
                                :navigation="false"
                                ref="swiper2"
                                class="swiper-2"
                                >
                                        <swiper-slide v-for="(image, index) in arResult.GALLERY.SMALL" :key="index">
                                            <span class="story-carousel__slide cp-slide">
                                                <img :src="image.src" alt="" :width="image.width" :height="image.height" loading="lazy" >
                                                <div class="swiper-lazy-preloader"></div>
                                            </span>
                                            
                                        </swiper-slide>
                                </swiper-container>   
                                <div class="next-vert-arrow" @click="goNextSlide" v-if="arResult.GALLERY.SMALL.length > 4">
                                    <svg width="11" height="20" viewBox="0 0 11 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.38296 20.0762C0.111788 19.805 0.111788 19.3654 0.38296 19.0942L9.19758 10.2796L0.38296 1.46497C0.111788 1.19379 0.111788 0.754138 0.38296 0.482966C0.654131 0.211794 1.09379 0.211794 1.36496 0.482966L10.4341 9.55214C10.8359 9.9539 10.8359 10.6053 10.4341 11.007L1.36496 20.0762C1.09379 20.3474 0.654131 20.3474 0.38296 20.0762Z" fill="currentColor" transform-origin="center" transform="rotate(180)"></path></svg>
                                </div> 
                            </div>
                            <div class="col-xl-9">
                                <div class="relative">
                                    <div class="actions" v-if="arResult.ACTIONS" v-for="ACTION in arResult.ACTIONS">
                                                <div class="item-promo-popular-peop" v-if="ACTION.VALUE=='3547'"></div> 
                                                <div class="item-promo-akcii"  v-if="ACTION.VALUE=='3546'"></div> 
                                                <div class="item-promo-new"  v-if="ACTION.VALUE=='3545'"></div>
                                                <div class="item-promo-xit"  v-if="ACTION.VALUE=='3548'"></div>
                                                <div class="item-promo-rent-i"  v-if="ACTION.VALUE=='3549'"></div>
                                                <div class="item-promo-del-i"  v-if="ACTION.VALUE=='6070'"></div>
                                    </div>
                                    <swiper-container
                                        :slides-per-view="1"
                                        class="swiper-1"
                                        :loop="true"
                                        navigation="true"
                                        thumbs-swiper=".swiper-2"
                                        effect="fade"
                                    >
                                        <swiper-slide v-for="(image, index) in arResult.GALLERY.LARGE" :key="index">
                                            <a class="cen-fl-img" :href="arResult.GALLERY.ORIGINAL[index].src"   
                                                @click.stop.prevent="showFancy(index)">
                                                <img  :src="image.src" alt="" :width="image.width" :height="image.height" loading="lazy">
                                                <div class="swiper-lazy-preloader"></div>
                                            </a>
                                            
                                        </swiper-slide>
                                        
                                    </swiper-container> 
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-4">
                        
                            <div class="shop-one">
                                
                                <div class="article" v-if="arResult.PROPS.CML2_ARTICLE">
                                    Артикул: {{arResult.PROPS.CML2_ARTICLE[0].VALUE}}
                                </div>
                                <div class="counter">
                                    {{arResult.SHOW_COUNTER}} просмотров товара за 2 месяца
                                </div>
                                <div class="po-desc">
                                    <span class="po-desc-h">Дополнительная информация</span>
                                    <div>
                                        <ul>
                                            <li v-for="item in arResult.PROPS">
                                                <span class="name">{{item[0].NAME}}:</span>
                                                <span v-if="item[0].VALUE_TEXT">{{item[0].VALUE_TEXT}}</span>
                                                <span v-if="!item[0].VALUE_TEXT">{{item[0].VALUE}}</span>
                                            </li>
                                        </ul>
                                    </div>
                                    
                                    
                                    
                                </div>
                                <a class="all-scr-char" href="" @click.stop.prevent="scrollToChar">Все характеристики</a>
                                <!-- <div class="mar-up-d-p disp-fl-spc" v-if="arResult.ACTIVE == 'Y'">
                                    <a class="b-pay-detail b-pay-detail-debt" @click="orderCredit">
                                            Купить в рассрочку
                                    </a>
                                
                                </div> -->
                                
                                <div class="offers" v-if="arResult.OFFERS">
                                    <div class="props" v-for="(prop, name) in arResult.OFFERS.PROPS">
                                        <label for="">{{name}}:</label>
                                        <div class="select">
                                            <select name="offers" id="offers" v-model="activeOffer" @change="changeOffer">
                                                <option :value="val.ID" v-for="(val, index) in prop" :selected="val.ID==activeOffer">{{val.VALUE}}</option>
                                            </select>
                                        </div>
                                    </div>
                                    
                                </div>

                                <div class="block-v" v-if="arResult.CUSTOM_OFFERS.length > 1">
                                    <label class='label-variants'>Варианты исполнения ({{arResult.CUSTOM_OFFERS.length}}):</label>
                                    <div class="block-variants">
                                        <div class="link-variant" v-if="arResult.CUSTOM_OFFERS">
                                            <a :href="offer.DETAIL_PAGE_URL" v-for="(offer, index) in arResult.CUSTOM_OFFERS" :class="{active:index==0}">
                                                {{offer.PROPS.OFFER_NAME?offer.PROPS.OFFER_NAME[0].VALUE:offer.NAME}}
                                            </a>

                                        </div>
                                    </div>
                                </div>
                                <div class="delivery-msk">
                                    <!-- Доставка по Москве для данного товара бесплатно
                                    <br>  -->
                                        Доставка по Москве <span v-if="arResult.PROPS.DELIVERY">{{arResult.PROPS.DELIVERY[0].VALUE_TEXT}}</span> <br>
                                        Доставка по всей России <span>от 3 до 5 дней</span>  
                                </div>
                                <div class="delivery-msk">
                                    
                                </div>
                                
<!-- 
                                <div class="delivery-paid">
                                    <div class="delivery-msk">
                                        <a href="/about/delivery/">Доставка</a>
                                    </div>
                                    <div class="paid-msk">
                                        <a href="/about/payment/">Оплата</a>
                                    </div>
                                </div> -->
                            </div>
                            
                    </div>
                    
                </div>
                <div class="row">
                    <div class="col-xl-12">
                        <v-tabs class="tab-disc-cont" v-model="tab" align-with-title>
                            <v-tab class="des psn-rel-disc">
                                Описание
                            </v-tab>
                            <v-tab>
                                Характеристики
                            </v-tab>
                            <v-tab v-html="'Отзывы с нашего магазина на OZON('+arResult.COUNT_FEEDBACKS+')'">
                            </v-tab>
                            <v-tab>
                                Инструкции
                            </v-tab>
                            <!-- <v-tab v-if="arResult.VIDEO_ADV">
                                Видео на Youtube ({{arResult.VIDEO_ADV.length}})
                            </v-tab> -->
                            <v-tab>
                                Вопрос ответ ({{arResult.COUNT_QUICKS}})
                            </v-tab>
                        </v-tabs>
                        <v-tabs-items v-model="tab" >
                                <v-tab-item  transition="fade-transition">
                                    
                                    <v-lazy>
                                        <div>
                                            <div class="hide-disc" v-html="arResult.DETAIL_TEXT" :class="{viewDisc: activeDescr}">
                                            </div>
                                            <div class="hide-disc-b">
                                                <span id="hide-disc-b-js" @click="showDisc" v-if="!activeDescr">
                                                    Развернуть
                                                </span>
                                                <span id="hide-disc-b-js" @click="showDisc" v-if="activeDescr">
                                                    Свернуть
                                                </span>
                                            </div>
                                        </div>
                                    </v-lazy>
                                    
                                </v-tab-item>
                                <v-tab-item  transition="fade-transition">
                                    
                                    <v-lazy>
                                        <ul class="char-tab-td">
                                            <li  v-for="item in arResult.PROPS">
                                                <span class="name">{{item[0].NAME}}:</span>
                                                <span v-if="item[0].VALUE_TEXT">{{item[0].VALUE_TEXT}}</span>
                                                <span v-if="!item[0].VALUE_TEXT">{{item[0].VALUE}}</span>
                                            </li>
                                        </ul>
                                    </v-lazy>
                                    
                                </v-tab-item>
                                <v-tab-item  transition="fade-transition">
                                
                                    <v-lazy>
                                    <div v-if="arResult.FEEDBACKS && tab=='2'">
                                        <!-- <ul v-if="arResult.FEEDBACKS && !pageFeed && tab=='2'">
                                            <li v-for="feed in arResult.FEEDBACKS">
                                                <feedback 
                                                    :feed="feed"
                                                ></feedback> 
                                            </li>
                                        </ul> -->
                                
                                        <feedbacks-card 
                                        :signed-parameters="ajaxParams.signedParameters"
                                        :token="ajaxParams.token"
                                        :id="this.originalId"
                                        :avg-rating="arResult.RATING"
                                        :count-feeds="getCountFeed(arResult)"
                                        >
                                        </feedbacks-card>
                                       
                                        <!-- <div v-if="!pageFeed" class="all-feeds b-pay-detail-cor-bas" @click="showPageFeedbacks">Показать все отзывы</div>-->
                                    </div> 
                                    </v-lazy>
                                    
                                </v-tab-item>
                                <v-tab-item  transition="fade-transition">
                                    
                                    <v-lazy>
                                    <div>
                                            <div class="ins" v-if="arResult.INSTRUCTION">
                                                <a :href="ins.VALUE_FILE.src" target="_blank" v-for="ins in arResult.INSTRUCTION">
                                                    {{ins.VALUE_FILE.name}} ({{ins.VALUE_FILE.file_size}})
                                                </a>
                                            </div>
                                            </div>
                                    </v-lazy>
                                    
                                </v-tab-item>
                                <!-- <v-tab-item transition="fade-transition" v-if="arResult.VIDEO_ADV">
                                    <v-lazy
                                        :options="{
                                        threshold: .5
                                        }"
                                        min-height="200"
                                        transition="fade-transition"
                                    >
                                    
                                            <div class="video-adv-f" v-if="arResult.VIDEO_ADV">
                                                <h3>Видео на Youtube по запросу {{arResult.NAME}}</h3> 
                                                <div class="video-more">
                                                        <a data-fancybox="" :href="'https://www.youtube.com/embed/'+video.VALUE" v-for="video in arResult.VIDEO_ADV">
                                                            <span class="title">{{video.DESCRIPTION}}</span>
                                                            <div class="video-wrapper">
                                                                <img :src="'//img.youtube.com/vi/'+video.VALUE+'/mqdefault.jpg'" class="lazy" width="100%" height="auto">
                                                            </div>
                                                        </a>      
                                                </div>            
                                                <p class="video-warning">Наш магазин никак не связан с этими видеороликами. Контент для ознакомления</p>         
                                            </div>
                                        
                                    </v-lazy>    
                                </v-tab-item> -->
                                <v-tab-item  transition="fade-transition">
                                    
                                    <v-lazy>
                                        <div>
                                            <!-- <div>
                                                <div class="h-faq-tabs">
                                                    Задайте вопрос о товаре?
                                                </div>
                                                <textarea class="area-faq-tabs" placeholder="Напишите свой вопрос" name="" id="" cols="30" rows="10">
                                                </textarea>
                                                <div class="sub-b-faq-tabs">
                                                    Отправить вопрос
                                                </div>
                                            </div> -->
                                            
                                            <quick-response 
                                            
                                            :signed-parameters="ajaxParams.signedParameters" 
                                            :token="ajaxParams.token"
                                            :id="this.originalId">

                                            </quick-response>
                                        </div>
                                    </v-lazy>

                                    
                                </v-tab-item>
                        </v-tabs-items>
                    </div>
                    <div class="col-xl-12">

                   
                            <!-- <v-lazy
                            :options="{
                            threshold: .5
                            }"
                            min-height="200"
                            transition="fade-transition"
                            v-model="showD"
                            v-if="arResult.PRICE > 2000 && arResult.PRICE < 30000"
                            >
                                <dolyami :product="arResult" v-if="showD"></dolyami>
                            
                            </v-lazy>   
                        -->
                                        
                    </div>
                </div>
            </div>
            
            <div class="col-xl-3">
                <div class="pos-sti old-pr-pos">
                    <div class="old-price-block" v-if="arResult.PRICE_OLD > 0">
                                <del class="dis-pr-old-pr-pos"  v-html="arResult.FORMAT_PRICE_OLD"></del>  
                                <div class="dis-pr">-{{arResult.DISCOUNT_PR}}%</div>
                    </div>
                    <div class="price-block">
                        <div class="price" v-html="arResult.FORMAT_PRICE"></div>
                        <div class="heart-like">

                            <a v-if="arResult.FAVORITE" class="eh-like-c-s active"  href="/favorite/" > <span></span> </a>
                            <a v-if="!arResult.FAVORITE" class="eh-like-c-s"  href="" @click.stop.prevent="addToFavorite(arResult)"> <span></span> </a>
                        </div>
                    </div>
                    <div class="price-block-basket">
                        <a class="price-block-basket-b" v-if="!arResult.BASKET && arResult.ACTIVE == 'Y'" @click.stop.prevent="addToBasket(arResult)" href="" >В корзину</a>
                        <a class="b-pay-detail-debt price-block-basket-b" href="/personal/cart/" v-if="arResult.BASKET" :class="{active: arResult.BASKET}" > 
                                            Перейти в корзину
                                        </a>

                        <div class="subscribe" v-if="arResult.ACTIVE == 'N' && !subscribeActive">
                            <input type="email" placeholder="Ваш e-mail" v-model="subscribeEmail" class="email-sub" required>
                            <a href="" class="b-pay-detail-cor-bas subscribe" @click.stop.prevent="sendSubscribe">Подписаться</a>    
                            <p>Как только товар появится у нас в наличии мы вас уведомим</p>                            
                        </div>    
                        <div class="subscribe-result" v-if="subscribeActive">
                            <p>Спасибо за подписку, как только товар появится в наличии мы с вами свяжемся</p>
                        </div>
                    </div>
                    
                    <!-- <a class="b-pay-detail b-pay-detail-cor-bas" href="" @click.stop.prevent="showFastBuy" v-if="arResult.ACTIVE == 'Y'">Быстрый заказ</a> -->
                    <div class="col-vo" v-if="arResult.ACTIVE == 'Y'">
                        <span class="col-vo-i">Товар доставим </span> 
                        <b v-if="arResult.PROPS.DELIVERY">{{arResult.PROPS.DELIVERY[0].VALUE_TEXT}}</b>
                    </div>
                    <div class="col-vo" v-if="arResult.ACTIVE == 'Y'">
                        <span class="col-vo-i">Товар в наличии </span> 
                        <b>есть</b>
                    </div>
                    <div class="col-vo" v-if="arResult.ACTIVE == 'N'">
                        <span class="col-vo-i out_stock">Нет в наличии </span> 

                    </div>
                </div>
            </div>
            </div>
        </div>    

            <popup-product :item="addProduct">
            </popup-product>
                    <div v-show="false">
                        <div class="hide-form">
                            <div class="row-flex">
                                <div class="left-block-img">
                                    <img :src="arResult.GALLERY.LARGE[0].src" alt="">
                                </div>
                                <div class="left-block-list">	
                                        <div class="data-product">		
                                                <div class="title-form">{{arResult.NAME}}</div>	
                                            <div class="price-group">
                                                <strong class="price">{{priceAfterDis | currency}}</strong>	
                                                <div class="text-dis">
                                                    <div class="old_price old-price-block">
                                                        <del class="dis-pr-old-pr-pos old-price-block" v-html="arResult.FORMAT_PRICE"></del>
                                                        <div class="dis-pr">10%</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                </div>	
                            </div>																							
                        </div>
                    </div>


    </div>
</template>